export const URL_KEY_TYPE = 'type';
export const URL_KEY_ID = 'id';
